var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "delivery-note-create-page main-content" }, [
    !_vm.initLoading
      ? _c(
          "form",
          {
            attrs: { action: "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submitDeliveryNoteData($event)
              },
            },
          },
          [
            _c("div", { staticClass: "page-header" }, [
              _vm.$route.name === "manually-delivery-notes.edit"
                ? _c("h3", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.$t("deliveryNotes.edit_delivery_note"))),
                  ])
                : _c("h3", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.$t("deliveryNotes.new_delivery_note"))),
                  ]),
              _vm._v(" "),
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/supplier/dashboard",
                        },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/supplier/delivery-notes",
                        },
                        slot: "item-title",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$tc("deliveryNotes.delivery_note", 2))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$route.name === "manually-delivery-notes.edit"
                  ? _c("li", { staticClass: "breadcrumb-item" }, [
                      _vm._v(
                        _vm._s(_vm.$t("deliveryNotes.edit_delivery_note"))
                      ),
                    ])
                  : _c("li", { staticClass: "breadcrumb-item" }, [
                      _vm._v(_vm._s(_vm.$t("deliveryNotes.new_delivery_note"))),
                    ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-actions row" },
                [
                  _vm.$route.name === "manually-delivery-notes.edit"
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "mr-3 base-button btn btn-outline-primary default-size invoice-action-btn",
                          attrs: {
                            href:
                              "/deliveryNotes/pdf/" +
                              _vm.newDeliveryNote.unique_hash,
                            target: "_blank",
                            outline: "",
                            color: "theme",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("general.view_pdf")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "invoice-action-btn",
                      attrs: {
                        loading: _vm.isLoading,
                        disabled: _vm.isLoading,
                        icon: "save",
                        color: "theme",
                        type: "submit",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("deliveryNotes.save_delivery_note")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row delivery-note-input-group" }, [
              _c(
                "div",
                { staticClass: "col-md-5 delivery-note-customer-container" },
                [
                  _vm.selectedCustomer
                    ? _c("div", { staticClass: "show-customer" }, [
                        _c("div", { staticClass: "row px-2 mt-1" }, [
                          _vm.selectedCustomer.billing_address
                            ? _c("div", { staticClass: "col col-6" }, [
                                _c("div", { staticClass: "row address-menu" }, [
                                  _c(
                                    "label",
                                    { staticClass: "col-sm-4 px-2 title" },
                                    [_vm._v(_vm._s(_vm.$t("general.bill_to")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm p-0 px-2 content" },
                                    [
                                      _vm.selectedCustomer.billing_address.name
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address.name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.billing_address
                                        .address_street_1
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address
                                                    .address_street_1
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.billing_address
                                        .address_street_2
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address
                                                    .address_street_2
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.billing_address
                                        .city &&
                                      _vm.selectedCustomer.billing_address.state
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address.city
                                                ) +
                                                ", " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address.state
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address.zip
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.billing_address
                                        .country
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address.country
                                                    .name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.billing_address.phone
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .billing_address.phone
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedCustomer.shipping_address
                            ? _c("div", { staticClass: "col col-6" }, [
                                _c("div", { staticClass: "row address-menu" }, [
                                  _c(
                                    "label",
                                    { staticClass: "col-sm-4 px-2 title" },
                                    [_vm._v(_vm._s(_vm.$t("general.ship_to")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm p-0 px-2 content" },
                                    [
                                      _vm.selectedCustomer.shipping_address.name
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .shipping_address.name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.shipping_address
                                        .address_street_1
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .shipping_address
                                                    .address_street_1
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.shipping_address
                                        .address_street_2
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .shipping_address
                                                    .address_street_2
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.shipping_address
                                        .city &&
                                      _vm.selectedCustomer.shipping_address
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .shipping_address.city
                                                ) +
                                                ", " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .shipping_address.state
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.selectedCustomer
                                                    .shipping_address.zip
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.shipping_address
                                        .country
                                        ? _c(
                                            "label",
                                            { staticClass: "country" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.selectedCustomer
                                                      .shipping_address.country
                                                      .name
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedCustomer.shipping_address
                                        .phone
                                        ? _c(
                                            "label",
                                            { staticClass: "phone" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.selectedCustomer
                                                      .shipping_address.phone
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "customer-content mb-1" }, [
                          _c("label", { staticClass: "email" }, [
                            _vm._v(_vm._s(_vm.selectedCustomer.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "action",
                              on: { click: _vm.editCustomer },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.edit")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "action",
                              on: { click: _vm.removeCustomer },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.deselect")))]
                          ),
                        ]),
                      ])
                    : _c(
                        "base-popup",
                        {
                          class: [
                            "add-customer",
                            {
                              "customer-required":
                                _vm.$v.selectedCustomer.$error,
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "add-customer-action",
                              attrs: { slot: "activator" },
                              slot: "activator",
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "customer-icon",
                                attrs: { icon: "user" },
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("customers.new_customer")) +
                                      " "
                                  ),
                                  _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(" * "),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.$v.selectedCustomer.$error &&
                                !_vm.$v.selectedCustomer.required
                                  ? _c("p", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("pos.errors.required")
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("customer-select-popup", {
                            attrs: { type: "deliveryNote" },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col delivery-note-input" }, [
                _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("deliveryNotes.delivery_note_date"))
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$v.newDeliveryNote.delivery_note_date.$touch()
                          },
                        },
                        model: {
                          value: _vm.newDeliveryNote.delivery_note_date,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newDeliveryNote,
                              "delivery_note_date",
                              $$v
                            )
                          },
                          expression: "newDeliveryNote.delivery_note_date",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newDeliveryNote.delivery_note_date.$error &&
                      !_vm.$v.newDeliveryNote.delivery_note_date.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("validation.required")) + " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-4" }, [
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("deliveryNotes.delivery_note_number"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("base-prefix-input", {
                        attrs: {
                          invalid: _vm.$v.deliveryNoteNumAttribute.$error,
                          prefix: _vm.deliveryNotePrefix,
                          icon: "hashtag",
                          readonly: true,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.deliveryNoteNumAttribute.$touch()
                          },
                        },
                        model: {
                          value: _vm.deliveryNoteNumAttribute,
                          callback: function ($$v) {
                            _vm.deliveryNoteNumAttribute = $$v
                          },
                          expression: "deliveryNoteNumAttribute",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$v.deliveryNoteNumAttribute.$error &&
                                !_vm.$v.deliveryNoteNumAttribute.required,
                              expression:
                                "$v.deliveryNoteNumAttribute.$error && !$v.deliveryNoteNumAttribute.required",
                            },
                          ],
                          staticClass: "text-danger mt-1",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$tc("pos.errors.required")) + "  "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.$v.deliveryNoteNumAttribute.numeric,
                              expression:
                                "!$v.deliveryNoteNumAttribute.numeric",
                            },
                          ],
                          staticClass: "text-danger mt-1",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$tc("validation.numbers_only")) +
                              "  "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("deliveryNotes.ref_number"))),
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: {
                          invalid:
                            _vm.$v.newDeliveryNote.reference_number.$error,
                          icon: "hashtag",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.newDeliveryNote.reference_number.$touch()
                          },
                        },
                        model: {
                          value: _vm.newDeliveryNote.reference_number,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newDeliveryNote,
                              "reference_number",
                              $$v
                            )
                          },
                          expression: "newDeliveryNote.reference_number",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newDeliveryNote.reference_number.$error
                        ? _c("div", { staticClass: "text-danger" }, [
                            _vm._v(
                              _vm._s(_vm.$tc("validation.ref_number_maxlength"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "item-table" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("thead", { staticClass: "item-table-header" }, [
                  _c("tr", [
                    _c("th", { staticClass: "text-left" }, [
                      _c(
                        "span",
                        { staticClass: "column-heading item-checkbox" },
                        [
                          _vm.POHasItems
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectAllDeliveryNoteItem,
                                    expression: "selectAllDeliveryNoteItem",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.selectAllDeliveryNoteItem
                                  )
                                    ? _vm._i(
                                        _vm.selectAllDeliveryNoteItem,
                                        null
                                      ) > -1
                                    : _vm.selectAllDeliveryNoteItem,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.selectAllDeliveryNoteItem,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectAllDeliveryNoteItem =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectAllDeliveryNoteItem = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectAllDeliveryNoteItem = $$c
                                      }
                                    },
                                    _vm.selectAllDeliveryNoteItems,
                                  ],
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-left" }, [
                      _c("span", { staticClass: "column-heading" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$tc("items.item", 2)) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-left" }, [
                      _c("span", { staticClass: "column-heading" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$tc("items.part_number", 2)) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-left" }, [
                      _c("span", { staticClass: "column-heading" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("pos.item.quantity")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  {
                    staticClass: "item-body",
                    attrs: { tag: "tbody", handle: ".handle" },
                    model: {
                      value: _vm.newDeliveryNote.items,
                      callback: function ($$v) {
                        _vm.$set(_vm.newDeliveryNote, "items", $$v)
                      },
                      expression: "newDeliveryNote.items",
                    },
                  },
                  _vm._l(_vm.newDeliveryNote.items, function (item, index) {
                    return _c("item", {
                      key: item.id,
                      attrs: {
                        ItemId: _vm.ItemId,
                        index: index,
                        "item-data": item,
                        currency: _vm.currency,
                        "order-items": _vm.newDeliveryNote.items,
                      },
                      on: {
                        remove: _vm.removeItem,
                        update: _vm.updateItem,
                        itemValidate: _vm.checkItemsData,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-item-action", on: { click: _vm.addItem } },
              [
                _c("font-awesome-icon", {
                  staticClass: "mr-2",
                  attrs: { icon: "shopping-basket" },
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("deliveryNotes.add_item")) +
                    "\n    "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.selectedDeliveryNoteItems.length
              ? _c(
                  "div",
                  {
                    staticClass: "add-item-action",
                    on: { click: _vm.removeMultipleItems },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: ["fas", "trash"] },
                    }),
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("general.delete")) + "\n    "
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "delivery-note-foot" }, [
              _c(
                "div",
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("deliveryNotes.notes")))]),
                  _vm._v(" "),
                  _c("base-text-area", {
                    attrs: { rows: "3", cols: "50" },
                    on: {
                      input: function ($event) {
                        return _vm.$v.newDeliveryNote.notes.$touch()
                      },
                    },
                    model: {
                      value: _vm.newDeliveryNote.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.newDeliveryNote, "notes", $$v)
                      },
                      expression: "newDeliveryNote.notes",
                    },
                  }),
                  _vm._v(" "),
                  _vm.$v.newDeliveryNote.notes.$error
                    ? _c("div", [
                        !_vm.$v.newDeliveryNote.notes.maxLength
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                _vm._s(_vm.$t("validation.notes_maxlength"))
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticClass: "mt-3 mb-1 d-block" }, [
                    _vm._v(
                      _vm._s(_vm.$t("deliveryNotes.delivery_note_template")) +
                        " "
                    ),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-template",
                      attrs: {
                        type: "button",
                        icon: "pencil-alt",
                        "right-icon": "",
                      },
                      on: { click: _vm.openTemplateModal },
                    },
                    [
                      _c("span", { staticClass: "mr-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("deliveryNotes.delivery_note_template")
                            ) +
                            " " +
                            _vm._s(_vm.getTemplateId) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "2%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "35%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "35%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "10%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }